<template>
    <div class="scan-page">
        <div v-if="loading" class="loading-mask">
            <p>{{loginText}}</p>
        </div>
        <div v-if="isWeb" class="loading-mask">
            <p>不支援外部瀏覽器，請在 LINE 應用程式內開啟。</p>
        </div>
    </div>
</template>

<script>
// import liff from '@line/liff';

export default {
    name: "LineLiff",
    data() {
        return {
            loading: true, // 用來製造無感跳轉/遮罩
            loginText: "載入中...",
            isWeb: false,  // 用於判斷是否在外部瀏覽器
            liffId: "2008934720-dx73LUSg", //process.env.VUE_APP_LIFF_ID, //liff id
            fromTo: "",
        };
    },
    async created() {
    },
    async mounted() {
        this.fromTo = localStorage.getItem("from");
        localStorage.removeItem("from");
        await this.initLiff();

    },

    methods: {
        async initLiff() {
            try {
                // 等待 init 完成
                // await this.$liffInitPromise;

                //再等 liff 初始化完成
                await this.$liff.ready;

                // 2. 嚴格檢查環境：liff.scanCodeV2() 必須在 LINE 內執行
                if (!this.$liff.isInClient()) {
                    this.loading = false; //關閉載入中文字
                    this.isWeb = true; // 顯示外部瀏覽器提示
                    return;
                }

                // 3. 處理登入狀態
                if (!this.$liff.isLoggedIn()) {
                    // 自動登入，登入後 LIFF 會自動跳回原頁面，並重新執行 initLiff
                    await this.$liff.login({redirectUri: window.location.href});
                    return;
                }

                // 4. 已登入且在 LINE 內 → 執行掃碼
                let getIDToken = this.$liff.getIDToken();
                let getAccessToken = this.$liff.getAccessToken();

                if (this.fromTo === "Scan") {
                    this.loading = false; //關閉載入中文字
                    await this.scanQRCode();
                    return;
                } else {
                    this.loading = false; //關閉載入中文字
                    this.$liff.closeWindow();
                    return;
                }

            } catch (err) {
                this.loading = false; //關閉載入中文字
                this.$liff.closeWindow();
            } finally {
                // 隱藏載入遮罩，但如果 isWeb 為 true 則保留提示畫面
                if (!this.isWeb) {
                    this.loading = false; //關閉載入中文字
                }
            }
        },
        async scanQRCode() {
            this.loading = true;
            this.loginText = '掃碼中...';
            try {
                if (this.fromTo === "Login") { //Login.vue呼叫使用取得授權
                    this.loading = false; //關閉載入中文字
                    localStorage.removeItem("from");
                    this.$liff.closeWindow();
                    return;
                }
                // liff掃碼
                if (!this.$liff.isInClient()) {
                     this.loading = false; //關閉載入中文字
                     this.isWeb = true; // 顯示外部瀏覽器提示
                     return;
                }

                //檢查目前版本是否支援該 API
                if (!this.$liff.isApiAvailable('scanCodeV2')) {
                    this.loginText = '您的 LINE 版本不支援掃描功能，請更新...';
                    return;
                }
                await this.$liff.ready;
                await new Promise(resolve => setTimeout(resolve, 200));
                const result = await this.$liff.scanCodeV2();
                if (result?.value) {
                    localStorage.setItem('qrcode', result.value);
                }
                this.loading = false; //關閉載入中文字
                this.$liff.closeWindow();


                // new Promise(resolve => {
                //     //跨域回傳值
                //     localStorage.setItem('qrcode', result.value);
                //     resolve(); // 立即完成
                // });
                //
                // // 3. 執行關閉
                // // **關鍵修正：加入微小延遲**
                // setTimeout(() => {
                //     this.$liff.closeWindow();
                // }, 500); // 嘗試延遲 50ms 或 100ms
                // }
            } catch (err) {
                this.loading = false; //關閉載入中文字
                // 如果掃碼失敗或使用者點擊取消，仍然需要關閉 LIFF 視窗
                this.$liff.closeWindow();
            }
        },
    },
};
</script>

<style>
.loading-mask {
    /* 保持原樣 */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
}
</style>